import axios from 'axios';
import { API } from '../config';

export default function PatientApi() {

    const loginPatient = async ({ mobile }) => {
        try {
            const result = await axios.post(`${API}/patientLogin`, { mobile })
            return result
        }
        catch (err) {
            return err;
        }
    };
    const PatientForgetMpin = async (bodyData) => {
        try {
            const result = await axios.post(`${API}/patientforgetmpin`, bodyData)
            return result
        }
        catch (err) {
            return err;
        }
    };

    const validLoginPatient = async ({ mobile }) => {
        try {
            const result = await axios.post(`${API}/forgetmpinpatientlogin`, { mobile })
            return result
        }
        catch (err) {
            return err;
        }
    };

    const patientSignUp = async (bodyData) => {
        try {
            const result = await axios.post(`${API}/patientsignup`, bodyData)
            return result
        }
        catch (err) {
            return err;
        }
    };

    const patientSignIn = async ({ mobile, password }) => {
        try {
            const result = await axios.post(`${API}/patientsignin`, { mobile, password })
            return result
        }
        catch (err) {
            return err;
        }
    };

    const patientLoginOtp = async ({ otp, _id }) => {
        try {
            const result = await axios.post(`${API}/patientLoginOtp`, { otp, _id })
            return result
        }
        catch (err) {
            return err;
        }
    };

    const fetchSessionSlotsData = async ({ doctorId, clinicId }) => {
        try {
            const result = await axios.get(`${API}/fetcSessionSlots/${doctorId}/${clinicId}`)
            return result.data
        }
        catch (err) {
            return err
        }
    };
    
    const paymentInfo = async (transactionData) => {
        try {
            const result = await axios.post(`${API}/payment/order`, transactionData)
            return result.data
        }
        catch (err) {
            return err
        }
    };

    const followupBooking = async (appointmentId, transactionData) => {
        try {
            const result = await axios.post(`${API}/booking/followup/${appointmentId}`, transactionData)
            return result.data
        }
        catch (err) {
            return err
        }
    };
    const getbookedSlots = async (doctorId, clinicId) => {
        try {
            const result = await axios.get(`${API}/getBookingData/${doctorId}/${clinicId}`)
            return result.data
        }
        catch (err) {
            return err
        }
    };

    const patientDetailsData = async ({ patientId }) => {
        try {
            const result = await axios.get(`${API}/patientById/${patientId}`)
            return result.data
        }
        catch (err) {
            return err
        }
    }

    const signup = async ({ patientId }, bodyData) => {
        try {
            const result = await axios.post(`${API}/insertPatientDetails/${patientId}`, bodyData)
            return result.data
        }
        catch (err) {
            return err;
        }
    };
    const getPatientLifestyle = async (patientId) => {
        try {
            const result = await axios.get(`${API}/fetchPatientLifestyleInfo/${patientId}`);
            return result.data
        }
        catch (err) {
            return err
        }
    }
    const getPatientMedical = async (patientId) => {
        try {
            const result = await axios.get(`${API}/fetchPatientMedicalInfo/${patientId}`);
            return result.data
        }
        catch (err) {
            return err
        }
    }

    const getPatientsByDoctorId = async (doctorId) => {
        try {
            const result = await axios.get(`${API}/getpatientsbydoctorId/${doctorId}`);
            return result.data
        }
        catch (err) {
            return err
        }
    }

    return {
        loginPatient,
        patientLoginOtp,
        fetchSessionSlotsData,
        paymentInfo,
        followupBooking,
        getbookedSlots,
        patientDetailsData,
        signup,
        getPatientLifestyle,
        getPatientMedical,
        getPatientsByDoctorId,
        patientSignUp,
        patientSignIn,
        PatientForgetMpin,
        validLoginPatient,
    }


}